import { observer } from "mobx-react";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useStore } from "../../app/stores/store";
import HeaderWrapper from "../header/HeaderWrapper";
import { PropertyModel } from "../../app/models/PropertyModel";
import ListingBox from "./ListingBox";
import AjaxLoader from "../../app/common/common-components/AjaxLoader";
import Breadcrumb from "../../app/common/common-components/Breadcrumb";
import apiAgent from "../../app/api/apiAgent";

export default observer(function SavePropertyPage() {
  const {
    userStore: { userSession },
  } = useStore();
  const location = useLocation();

  // Get property ID from URL
  const params = new URLSearchParams(location.search);
  const propertyId = params.get("ID") || "";

  // Use React Query to fetch property data
  const { data: property, isLoading } = useQuery<PropertyModel>({
    queryKey: ["property", propertyId],
    queryFn: () => apiAgent.Property.saveProperty(propertyId),
    enabled: true,
  });

  // Set page title
  useEffect(() => {
    document.title = "Base - Save Listing";
  }, []);

  const queryClient = useQueryClient();

  const handlePropertySaved = () => {
    queryClient.invalidateQueries({ queryKey: ["property", propertyId] });
  };

  if (isLoading) {
    return <AjaxLoader />;
  }

  return (
    <>
      <div className="save-property-page container-fluid">
        <Breadcrumb
          breadcrumbs={[
            { text: "Home", path: "/" },
            { text: "Listings", path: "/Property" },
            { text: !property?.propertyID ? "Create" : property?.displayName },
          ]}
        />
        <div className="row">
          <div className="hidden-sm col-md-2"></div>
          <div id="content" className="col-sm-12 col-md-8">
            <ListingBox
              data={property}
              favourite={property?.favourite}
              OfficeContactTags={property?.officeContactTags}
              UserContactTags={property?.userContactTags}
              OwnershipTypes={property?.ownershipTypes}
              PropertyTypes={property?.propertyTypes}
              MandateTypes={property?.mandateTypes}
              AgentTypes={property?.agentTypes}
              DiaryActionTags={property?.diaryActionTags}
              actions={property?.actions}
              IsSuperAdmin={property?.isSuperAdmin}
              OnShowStart={property?.onShowStart}
              OnShowEnd={property?.onShowEnd}
              CurrencyDisplay={property?.currencyDisplay}
              ContactSourceTypes={property?.contactSourceTypes}
              DialingCodeDD={property?.dialingCodeDD}
              DialingCode={property?.dialingCode}
              Brochures={property?.brochures}
              AgentDD={property?.agentDD}
              SelectedAgentID={property?.selectedAgentID}
              ListingSellerRequired={property?.listingSellerRequired}
              ExtraDescriptionFieldsDD={property?.extraDescriptionFieldsDD}
              CountryDD={property?.countryDD}
              ExtraDescriptionTagFields={property?.extraDescriptionTagFields}
              ShowChart={property?.showChart}
              GeneralListingTags={property?.generalListingTags}
              userSession={userSession}
              ListingTags={property?.listOfListingTags}
              onPropertySaved={handlePropertySaved}
            />
          </div>
          <div className="hidden-sm col-md-2"></div>
        </div>
      </div>
    </>
  );
});
